/** @jsxImportSource @emotion/react */
import { Box, Button, DialogActions, DialogContent, Divider, Grid, Paper, Snackbar, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useContext, useState } from 'react';
import ElevatedGrid from '../../Components/ElevatedGrid';
import { Il8nContext } from '../../Helper/i18n';
import PageLayout from '../Layout/PageLayout';
import { useEffect } from 'react';
import MySnackbarContentWrapper from '../../Components/Snackbars';
import config from '../../config';
import axios from '../../Helper/Axios/interceptor';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { steps } from '../../Helper/AppStepperData';
import FullScreenLoader from '../../Components/FullScreenLoader';
import { addStageData, updateStepper } from '../../Helper/Redux/reducers/upDown';
import { downloadPDF } from '../../Helper/Functions';
import Popup, { PopupTitle } from '../../Components/CustomPopup';
import NomineeEsignDialog from './NomineeEsignDialog';
import PopupBlockerAlert from './PopupBlockerAlert';
import { StyledTextField } from '../../Components/CustomTextfield';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { deleteCookie, setCookie } from '../../Helper/Cookies/cookies';
let popupTestCounter = false
let hasFalseValue
function Submit(props) {
    const theme = useTheme();
    const store = useSelector(state => state.storeState.stage)
    const stepper = useSelector(state => state.storeState.stepper)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'))
    const [snackBarOpen, setSnackBarOpen] = useState(false);
    const [responseStatus, setResponseStatus] = useState({})
    const [loading, setLoading] = useState(false);
    const [isEmailVerified, setIsEmailVerified] = useState(false)
    const [openConfirmPhysicalSubmitPopup, setOpenConfirmPhysicalSubmitPopup] = useState(false)
    const [openRedirectPopup, setOpenRedirectPopup] = useState({ state: false, message: "" })
    const [isPhysicalFormSubmission, setIsPhysicalFormSubmission] = useState()
    const [ESignDialogState, setESignDialogState] = useState({ show: false, esignData: [], disableClient: true })
    const [clientName, setClientName] = useState("")
    const [openPopupBlockerAlert, setOpenPopupBlockerAlert] = useState(false)
    const [stageData, setStageData] = useState(null)
    const localeText = useContext(Il8nContext)
    const location = useLocation()

    const rightSection = [
        {
            "number": localeText?.caseStepper1,
            "title": localeText?.caseStepperTitle1,
            "description": localeText?.caseStepperDescription1,
        },
        {
            "number": localeText?.caseStepper2,
            "title": localeText?.caseStepperTitle2,
            "description": localeText?.caseStepperDescription2,
        },
        {
            "number": localeText?.caseStepper3,
            "title": localeText?.caseStepperTitle3,
            "description": localeText?.caseStepperDescription3,
        }
    ];

    const leftSection = [
        {
            "title": localeText?.leftStepperTitle1,
            "description": localeText?.leftStepperDescription1,
        },
        {
            "title": localeText?.leftStepperTitle2,
            "description": localeText?.leftStepperDescription2,
        },
        {
            "title": localeText?.leftStepperTitle3,
            "description": localeText?.leftStepperDescription3,
        },
        {
            "title": localeText?.leftStepperTitle4,
            "description": localeText?.leftStepperDescription4,
        }
    ]

    useEffect(() => {
        if (!store.isFreshUser) {
            dispatch(addStageData({ ...store, isFreshUser: false }))
        }
    }, [])

    useEffect(() => {
        getStageDetails()
        !(stepper?.length) && dispatch(updateStepper({ setDirectly: true, stepper: [1, 3, 3, 2] }))
    }, [])

    const getStageDetails = () => {
        setLoading(true)
        axios.get(process.env.REACT_APP_API_URL + config.stageDetails)
            .then(resp => {
                if (resp.data.success) {
                    setStageData(resp?.data?.success)
                    setLoading(false)
                } else {
                    throw new Error()
                }
            }).catch((err) => {
                console.log(err.message)
                setLoading(false)
            })
    }

    function handleSnackBarClose() {
        setSnackBarOpen(false)
        setResponseStatus()
    }

    const toggleConfirmPhysicalSubmitPopup = () => {
        setOpenConfirmPhysicalSubmitPopup(!openConfirmPhysicalSubmitPopup)
    }

    const handlePhysicalFormSubmission = () => {
        setIsPhysicalFormSubmission(true)
        toggleConfirmPhysicalSubmitPopup()
        togglePopupBlockerAlertDialog()
    }

    const nextNavigation = () => {
        navigate("/Courier")
    }

    const downloadPhysicalForm = () => {
        setLoading(true)
        let payload = {
            "kycId": stageData?.kycId || null,
        }
        axios.post(process.env.REACT_APP_API_URL + config.physicalDownload, payload)
            .then(resp => {
                setLoading(false)
                if (resp.data.success) {
                    downloadPDF(resp.data.File)
                    nextNavigation()
                }
                else {
                    throw new Error(resp.data.error)
                }
            })
            .catch(error => {
                setLoading(false)
                setResponseStatus({ "message": error.message, "type": "error" })
                setSnackBarOpen(true)
            })
    }

    const checkIfNomineeEsignPending = (data) => {
        let isEsignRequired = false;
        let findNominee = data.find(ele => (ele.isESignNomineeRequired && !ele.isESignNomineeDone))
        if (findNominee) {
            isEsignRequired = true
        } else {
            let findGuardian = data.find(ele => (ele.guardian.isESignGuardianRequired && !ele.guardian.isESignGuardianDone))
            if (findGuardian) {
                isEsignRequired = true
            }
        }
        return isEsignRequired;
    }

    const handleNomineeEsignStatus = (type) => {
        let data = { ...ESignDialogState }
        if (data.esignData[type.count - 1]) {
            if (type.nominee) {
                data.esignData[type.count - 1]["isESignNomineeDone"] = true
            }
            else {
                data.esignData[type.count - 1]["guardian"]["isESignGuardianDone"] = true
            }
        }
        let check = checkIfNomineeEsignPending(data.esignData)
        if (!check) {
            data.disableClient = false
        }
        setESignDialogState(data)
    }

    const verifyPanDetails = (eSignDetails) => {
        let payload = {
            "isPanReVerified": false
        }
        axios.post(process.env.REACT_APP_API_URL + config.reVerify, [payload])
            .then(resp => {
                setLoading(false)
                if(resp.data.success){
                    VerifyEsign(eSignDetails)
                }else if(resp.data.error){
                    setOpenRedirectPopup({state:true, message:resp.data.error})
                }
            }).catch(err => {
                setLoading(false)
                setResponseStatus({ "message": err.message, "type": "error" })
                setSnackBarOpen(true)
                setOpenRedirectPopup({state:true, message:err.message})
            })
    }

    const getESign = (data, eSignDetails) => {
        let payload = {
            "kycId": stageData?.kycId || null,
            "signerType": eSignDetails.signer,
            "signerNumber": "1",
            "msg": data
        }
        setLoading(true)
        axios.post(`${process.env.REACT_APP_API_URL}${config.getEsignDoc}`, payload)
            .then(response => {
                if (response.data.success) {
                    setLoading(false)
                    setResponseStatus({ "message": response.data.success, "type": "success" })
                    setSnackBarOpen(true)
                    if (eSignDetails.user) {
                        setESignDialogState({ show: false, esignData: [], disableClient: true })
                        localStorage.setItem("esignStatus", "done")
                        nextNavigation()
                    }
                    else {
                        handleNomineeEsignStatus(eSignDetails)
                    }
                }
                else if (response.data.error) {
                    throw new Error(response.data.error)
                }
            })
            .catch(exception => {
                setResponseStatus({ "message": exception.message, "type": "error" })
                setSnackBarOpen(true)
                setLoading(false)
            })
    }

    const VerifyEsign = (eSignDetails) =>{
        setLoading(true)
        const PAGE_OPENED = 1;
        const NSDL_RESPONSE = 2;
        let payload = {
            "kycId": stageData?.kycId || null,
            "signerType": eSignDetails.signer,
            "signerNumber": "1"
        }
        axios.post(`${process.env.REACT_APP_API_URL}${config.esign}`, payload)
            .then(response => {
                if (response.data.success) {
                    setLoading(false)
                    let esign = window.open(process.env.REACT_APP_ESIGN_REDIRECT, "_blank")
                    window.onmessage = e => {
                        let data = JSON.parse(e.data);
                        switch (data.key) {
                            case PAGE_OPENED: esign.postMessage(response.data.success, "*");
                                break;
                            case NSDL_RESPONSE: getESign(data.data, eSignDetails); esign.close();
                                break;
                        }
                    }
                }
                else if (response.data.error) {
                    throw new Error(response.data.error)
                }
            })
            .catch(exception => {
                setResponseStatus({ "message": exception.message, "type": "error" })
                setSnackBarOpen(true)
                setLoading(false)
            })
    }

    const handleESign = (eSignDetails) => {
        if(store?.isFreshUser || location?.state?.isFinalSubmitUser){
            VerifyEsign(eSignDetails)
        }else{
            verifyPanDetails(eSignDetails)
        }
    }

    const checkNomineeEsign = (data) => {
        let required = checkIfNomineeEsignPending(data)
        if (required) {
            setESignDialogState({ ...ESignDialogState, esignData: data, show: true })
        } else {
            handleESign({ signer: "applicantSignature", user: true })
        }
    }

    const checkIfNomineeEsignReq = () => {
        let reviewData = JSON.parse(localStorage.getItem("reviewData"))
        let data = reviewData?.kycNominee?.map(nominee => {
            return {
                "nomineeFirstName": nominee.nomineeFirstName,
                "guardian": nominee.guardian,
                "signerType": nominee.signerType,
                "isESignNomineeDone": nominee.isESignNomineeDone,
                "isESignNomineeRequired": nominee.isESignNomineeRequired
            }
        })
        setClientName(reviewData?.kycStagingPersonalDetails?.clientFirstName + " " + reviewData?.kycStagingPersonalDetails?.clientMiddleName + " " + reviewData?.kycStagingPersonalDetails?.clientLastName)
        if (data?.length > 0) {
            checkNomineeEsign(data)
        } else {
            handleESign({ signer: "applicantSignature", user: true })
        }
    }

    const handleESignSubmission = () => {
        setIsPhysicalFormSubmission(false)
        togglePopupBlockerAlertDialog()
    }

    const getView = () => {
        return (
            <Grid container item alignItems={"start"} spacing={3}>
                <Grid item xs={12} md={6} css={{ paddingBottom: "10px" }}>
                    <Paper elevation={2} css={{ width: "100%", borderRadius: "15px" }}>
                        <Grid container spacing={3} alignItems={"center"} justifyContent={"center"} css={{ padding: "40px" }}>
                            <Grid item xs={12}>
                                <Typography display="inline" variant="h6" fontWeight={"bold"} color="#525D72">
                                    {localeText?.finalSubmitSignOnlinewithAdhaarOtp}
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <img src={"/images/icon_pointer.svg"} alt="radioButton" css={{ verticalAlign: "middle" }} />
                                <Typography display="inline" variant="body2" color="#707070">
                                    {localeText?.finalSubmitNoAttestationReq}
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <img src={"/images/icon_pointer.svg"} alt="radioButton" css={{ verticalAlign: "middle" }} />
                                <Typography display="inline" variant="body2" color="#707070">
                                    {localeText?.finalSubmitNoPhysicalFormRequired}
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <img src={"/images/icon_pointer.svg"} alt="radioButton" css={{ verticalAlign: "middle" }} />
                                <Typography display="inline" variant="body2" color="#707070">
                                    {localeText?.finalSubmitNoTeleVerificationReq}
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Button variant="contained" color="primary" disabled={hasFalseValue} onClick={handleESignSubmission}>
                                    {localeText?.finalSubmitContinueESign}
                                </Button>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Paper elevation={2} css={{ width: "100%", borderRadius: "15px" }}>
                        <Grid container spacing={3} alignItems={"center"} justifyContent={"center"} css={{ padding: "40px" }}>
                            <Grid item xs={12}>
                                <Typography display="inline" variant="h6" fontWeight={"bold"} color="#525D72">
                                    {localeText?.finalSubmitMobileAadhaarnotLinked}
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant="body1" color="#0098B0" fontWeight={"bold"}>
                                    {localeText?.finalSubmitTakePrintCourier}
                                </Typography>
                                <img src={"/images/icon_pointer.svg"} alt="radioButton" css={{ verticalAlign: "middle" }} />
                                <Typography display="inline" variant="body2" color="#707070">
                                    {localeText?.finalSubmitSignEveryPage}
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant="body1" color="#0098B0" fontWeight={"bold"}>
                                    {localeText?.finalSubmitCourierOfficeAddress}
                                </Typography>
                                <img src={"/images/icon_pointer.svg"} alt="radioButton" css={{ verticalAlign: "middle" }} />
                                <Typography display="inline" variant="body2" color="#707070">
                                    {localeText?.finalSubmitMainOfficeAddress}
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant="body1" color="#0098B0" fontWeight={"bold"}>
                                    {localeText?.finalSubmitContactforQueries}
                                </Typography>
                                <Grid container item xs={12}>
                                    <Grid item xs={12}>
                                        <div>
                                            <img src={"/images/icon_mail.svg"} alt="radioButton" css={{ verticalAlign: "middle", width: "20px", height: "20px" }} />
                                            <Typography display="inline" variant="body2" color="#707070" css={{ padding: "0 10px" }}>
                                                {localeText?.finalSubmitEmailID}
                                            </Typography>

                                        </div>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <div>
                                            <img src={"/images/icon_smartphone.svg"} alt="radioButton" css={{ verticalAlign: "middle", width: "20px", height: "20px" }} />
                                            <Typography display="inline" variant="body2" color="#707070" css={{ paddingLeft: "10px" }}>
                                                {localeText?.finalSubmitMobNum}
                                            </Typography>

                                        </div>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <Button variant="contained" color="primary" onClick={toggleConfirmPhysicalSubmitPopup}>
                                    {localeText?.finalSubmitDonwloadContinue}
                                </Button>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>
        )
    }

    const togglePopupBlockerAlertDialog = () => {
        setOpenPopupBlockerAlert(!openPopupBlockerAlert)
    }

    const checkIfPopupBlockerIsEnabled = (isPopupRedirectionBlocked) => {
        let popupTest = window.open("", "_blank")
        if (!popupTest || popupTest.closed || typeof popupTest.closed == 'undefined') {
            isPopupRedirectionBlocked = true;
            popupTestCounter = 0;
            setResponseStatus({ "message": localeText?.finalSubmitBlocker, "type": "error" });
            setSnackBarOpen(true);
        }
        else if (popupTestCounter < 1) {
            popupTestCounter++;
            isPopupRedirectionBlocked = checkIfPopupBlockerIsEnabled(isPopupRedirectionBlocked)
        }
        popupTest && popupTest.close()
        return isPopupRedirectionBlocked;
    }

    const handlePopupDialogOkayClick = () => {
        if (!(checkIfPopupBlockerIsEnabled(false))) {
            popupTestCounter = 0;
            togglePopupBlockerAlertDialog()
            if (isPhysicalFormSubmission) {
                downloadPhysicalForm()
            }
            else {
                checkIfNomineeEsignReq()
            }
        }
    }

    function getMajorDate(years) {
        let date = new Date()
        date.setFullYear(date.getFullYear() - years)
        date.setDate(date.getDate() - 1)
        date = new Date(date.getTime())
        return date
    }

    const handleSubmit = (values) => {
        const dateObject = new Date(values?.dateOfBirth);
        const formattedDob = ('0' + dateObject.getDate()).slice(-2) + '/' + ('0' + (dateObject.getMonth() + 1)).slice(-2) + '/' + dateObject.getFullYear();
        setLoading(true)
        let payload = {
            "firstName": values.firstName,
            "middleName": values.middleName,
            "lastName": values.lastName,
            "dob": formattedDob,
            "isPanReVerified": true
        }
        axios.post(process.env.REACT_APP_API_URL + config.reVerify, [payload])
            .then(resp => {
                setLoading(false)
                if (resp.data.success) {
                    setOpenRedirectPopup({ state: false })
                    VerifyEsign({ signer: "applicantSignature", user: true })
                } else if (resp.data.error) {
                    setOpenRedirectPopup({ state: true, message: resp.data.error })
                }
            }).catch(err => {
                setLoading(false)
                setResponseStatus({ "message": err.message, "type": "error" })
                setSnackBarOpen(true)
                setOpenRedirectPopup({ state: true, message: err.message })
            })
    }

    const validationSchema = yup.object({
        firstName: yup
            .string('Fisrt Name is required')
            .matches(/^[a-zA-Z'.()&]+(?: [a-zA-Z'.()&]+)*$/, localeText?.validFirstNameAsPerPan)
            .required(localeText?.firstNameAsperPanRequired),
        middleName: yup
            .string('Middle Name is required')
            .matches(/^[a-zA-Z'.()&]+(?: [a-zA-Z'.()&]+)*$/, localeText?.validMiddleNameAsPerPan),
        lastName: yup
            .string('Last Name is required')
            .matches(/^[a-zA-Z'.()&]+(?: [a-zA-Z'.()&]+)*$/, localeText?.validLastNameAsPerPan),
        dateOfBirth: yup
            .date('')
            .required(localeText?.kycVerificationDateOfBirthRequired)
            .nullable(),
    });
    const formik = useFormik({
        initialValues: {
            panNumber: '',
            firstName: '',
            middleName: '',
            lastName: '',
            dateOfBirth: null,
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            handleSubmit(values)
        },
    });

    const handleVisitWebsite = () => {
        const url = process.env.REACT_APP_CORPORATE_URL;
        if (url) {
            window.open(url, "_blank");
        } else {
            console.log('URL is not defined');
        }
    }


    return (
        <>
            {!stageData?.isFinalEsign ? <>
                    <PageLayout css={{ overflowY: "scroll" }} hideSidebarGrid={true} calculateHeight={true}>
                    <div style={{
                        height: "calc(100% + 30px)",
                        marginBottom: -30
                    }}>
                        <div style={{height:`calc(100% - ${isSmallScreen ? 140 : 70 }px)`,overflow:'auto'}}>
                            <Grid style={{ display: 'flex',flexDirection: isSmallScreen ? 'column' : 'row', alignItems: 'center' }}>
                                <div style={{ marginRight: '2rem' }}>
                                    <img src="/images/great_Icon.svg" style={{ maxWidth: '100%', height: 'auto' }}></img>
                                    </div>
                                <div>
                                    <Typography variant="h3" style={{ color: '#24B7CC' }}>
                                        {localeText?.finalSubmit}
                                    </Typography>
                                    <Typography variant="h4" gutterBottom style={{ fontWeight: 'bold', fontSize: isSmallScreen ? '1rem' : '2.125rem',fontWeight: '900'  }}>
                                        {localeText?.scrutinySubmitted}
                                    </Typography>
                                    <Typography variant="body1" gutterBottom>
                                        {localeText?.scrutinySubTitle}
                                    </Typography>
                                </div>
                            </Grid>
                            <Grid container spacing={4}>
                                <Grid item xs={12} md={7} lg={7} sm={12}>
                                    <div style={{ display: 'flex',flexDirection: isSmallScreen ? 'column' : 'row',justifyContent: "flex-start",alignItems: isSmallScreen ? "center" :'flex-end', borderBottom: '3px solid #303030' }}>
                                        <img src="/images/think_Icon.svg" style={{ maxWidth: '100%', height: 'auto'}}></img>
                                        <Typography variant="h4" gutterBottom sx={{ color: '#24B7CC', fontWeight: 'bold' }}>
                                            {localeText?.submitTitle}
                                        </Typography>
                                    </div>
                                    <ol>
                                        {leftSection?.map((item, i) => (
                                            <li key={i} style={{ marginBottom: '10px' }}>
                                                <div>
                                                    <strong>{item?.title}:</strong>
                                                </div>
                                                <div>{item?.description}</div>
                                            </li>
                                        ))}
                                    </ol>
                                </Grid>

                                <Grid item xs={12} md={5} lg={5} sm={12}>
                                    <div style={{ display: 'flex',flexDirection: isSmallScreen ? 'column' : 'row',justifyContent: "flex-start",alignItems: isSmallScreen ? "center" :'flex-end', borderBottom: '3px solid #303030' }}>
                                        <img src="/images/alert_Icon.svg" style={{ maxWidth: '100%', height: 'auto', margin: '5px' }}></img>
                                        <Typography variant="h4" gutterBottom style={{ color: '#24B7CC', fontWeight: 'bold' }}>
                                            {localeText?.rightSectionHeader}
                                        </Typography>
                                    </div>
                                    <Typography variant="body2" gutterBottom style={{ padding: '10px' }}>
                                        {localeText?.rightSectionDesc}
                                    </Typography>
                                    {rightSection?.map((step) => (
                                        <li key={step.number} style={{ marginBottom: '16px', listStyleType: 'none' }}>
                                            <Stack spacing={1} sx={{ mb: 3 }}>
                                                <Typography
                                                    variant="body1"
                                                    sx={{ display: 'flex', alignItems: 'center', fontWeight: 'bold' }}
                                                >
                                                    <Box sx={{ color: '#5A1D1D', opacity: '1', marginRight: '8px' }}>
                                                        {step.number}
                                                    </Box>
                                                    {step.title}
                                                </Typography>
                                                <Typography variant="body1" sx={{ pl: 3 }}>
                                                    {step.description}
                                                </Typography>
                                            </Stack>
                                        </li>
                                    ))}
                                </Grid>
                            </Grid>
                        </div>
                        <Grid style={{
                            display: "flex",
                            backgroundColor: "rgb(239, 237, 237)",
                            justifyContent:'flex-start',
                            alignItems:'center',
                            padding: "10px",
                            margin: "0px -30px -30px -30px",
                            height: isSmallScreen ? "140px" : "70px"
                        }}>
                            <Typography variant="h6" gutterBottom style={{ marginLeft: '10px', fontWeight: 'bold' }}>
                                {localeText?.visitWebsiteLabel}
                            </Typography>
                            <Button variant="contained" color="primary" onClick={handleVisitWebsite} style={{ marginLeft: '3rem' }}>
                                {localeText?.visitWebsite}
                            </Button>
                        </Grid>
                    </div>
                </PageLayout>
            </> :
                <PageLayout css={{ overflowY: "scroll" }} hideSidebarGrid={true} calculateHeight={true}>
                    {isSmallScreen ?
                        <ElevatedGrid >
                            {getView()}
                        </ElevatedGrid>
                        : getView()
                    }
                </PageLayout>}

            {loading && <FullScreenLoader />}

            <PopupBlockerAlert showPopupEnablingGuide openPopupBlockerAlert={openPopupBlockerAlert} handlePopupBlockerAlertDialog={togglePopupBlockerAlertDialog} handlePopupDialogOkayClick={handlePopupDialogOkayClick} />

            {ESignDialogState.show &&
                <NomineeEsignDialog
                    clientName={clientName}
                    data={ESignDialogState || {}}
                    onEsignClick={handleESign}
                    handleClose={() => setESignDialogState({ show: false, esignData: [], disableClient: true })}
                />}

            <Popup
                open={openConfirmPhysicalSubmitPopup}
                maxWidth={"sm"}
            >
                <PopupTitle dontShowCloseIcon customCSS={{ textAlign: "center" }}>
                    {localeText?.finalSubmitConfirmSubmission}
                </PopupTitle>
                <DialogContent /* css={{ textAlign: "center", margin: "0px 30px" }} */>
                    <Typography variant="body1" css={{ padding: "20px 0px" }}>
                        {localeText?.finalSubmitContinuePhysicalProcess}
                    </Typography>
                    <DialogActions>
                        <Button variant="contained" color="primary" onClick={handlePhysicalFormSubmission}>
                            {localeText?.finalSubmitYes}
                        </Button>
                        <Button variant="outlined" color="primary" onClick={toggleConfirmPhysicalSubmitPopup}>
                            {localeText?.finalSubmitNo}
                        </Button>
                    </DialogActions>
                </DialogContent>
            </Popup>
            <Popup
                open={openRedirectPopup?.state}
                minWidth={"lg"}
            >
                <PopupTitle dontShowCloseIcon backgroundColor={"#24B7CC"} customCSS={{ textAlign: "center" }}>
                    {openRedirectPopup?.message}
                </PopupTitle>
                <form autocomplete="off" onSubmit={formik.handleSubmit} css={{ width: "100%" }}>
                    <DialogContent>
                        <Grid item lg={4} md={6} xs={12}>
                            <StyledTextField id="firstName" name="firstName" css={{ marginTop: "10px" }}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                required
                                value={formik.values.firstName}
                                error={formik.touched.firstName && Boolean(formik.errors.firstName)}
                                helperText={formik.touched.firstName && formik.errors.firstName}
                                inputProps={{ maxLength: 100 }} fullWidth
                                label={localeText?.kycFirstNameAsPerPan} variant="outlined"
                                onChange={(e) => {
                                    formik.handleChange(e)
                                    formik.setFieldValue('firstName', e.currentTarget.value)
                                }}
                            />
                        </Grid>
                        <Grid item lg={4} md={6} xs={12}>
                            <StyledTextField id="middleName" name="middleName" css={{ marginTop: "10px" }}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={formik.values.middleName}
                                error={formik.touched.middleName && Boolean(formik.errors.middleName)}
                                helperText={formik.touched.middleName && formik.errors.middleName}
                                inputProps={{ maxLength: 100 }} fullWidth
                                label={localeText?.kycMiddleNameAsPerPan} variant="outlined"
                                onChange={(e) => {
                                    formik.handleChange(e)
                                    formik.setFieldValue('middleName', e.currentTarget.value)
                                }}
                            />
                        </Grid>
                        <Grid item lg={4} md={6} xs={12}>
                            <StyledTextField id="lastName" name="lastName" css={{ marginTop: "10px" }}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={formik.values.lastName}
                                error={formik.touched.lastName && Boolean(formik.errors.lastName)}
                                helperText={formik.touched.lastName && formik.errors.lastName}
                                inputProps={{ maxLength: 100 }} fullWidth
                                label={localeText?.kycLastNameAsPerPan} variant="outlined"
                                onChange={(e) => {
                                    formik.handleChange(e)
                                    formik.setFieldValue('lastName', e.currentTarget.value)
                                }}
                            />
                        </Grid>
                        <Grid item xl={4} lg={4} md={6} xs={12}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker css={{ width: "100%", marginTop: "10px" }}
                                    inputFormat="DD/MM/YYYY"
                                    id="dateOfBirth" name="dateOfBirth"
                                    value={formik.values.dateOfBirth}
                                    maxDate={getMajorDate(18)}
                                    label={localeText?.kycVerificationDate}
                                    onChange={e => {
                                        formik.setFieldValue("dateOfBirth", (e && e.$d && e?.$d !== 'Invalid Date') ? e.$d : "")
                                    }}
                                    renderInput={(params) => <StyledTextField
                                        fullWidth
                                        required
                                        error={formik.touched.dateOfBirth && Boolean(formik.errors.dateOfBirth)}
                                        helperText={formik.touched.dateOfBirth && formik.errors.dateOfBirth}
                                        {...params}
                                    />}
                                />
                            </LocalizationProvider>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="outlined" color="error" type="submit">
                            {localeText?.finalSubmitVerifyNow}
                        </Button>
                    </DialogActions>
                </form>
            </Popup>

            {responseStatus && responseStatus.message && <Snackbar
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                open={snackBarOpen}
                autoHideDuration={5000}
                onClose={handleSnackBarClose}
            >
                <MySnackbarContentWrapper
                    onClose={handleSnackBarClose}
                    variant={responseStatus.type}
                    message={responseStatus.message}
                />
            </Snackbar>}
        </>
    );
}

export default Submit;